import { useMediaQuery, useTheme, Button } from '@mui/material'

import { EditIcon } from 'src/assets/icons'

import { BillingTransactionsTable } from './table.component'
import { BillingTransactionsList } from './list.component'
import { useAccountTransactions, useCreatePortalSession } from 'src/hooks'

import { useStyles } from '../../account-support/styles'
import { useStyles as useStyles1 } from './styles'
import { SubscriptionEnd } from './subscription-end.component'
import { HelperWrapper } from 'src/components/helper-wrapper'

const BillingTransactions = () => {
  const { mutateAsync: createSession } = useCreatePortalSession()
  const { data, isLoading } = useAccountTransactions()

  const classes = useStyles()
  const classes1 = useStyles1()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const handleSessionCreate = async () => {
    const link = await createSession()

    if (!link) return

    window.open(link, '_self')
  }

  return (
    <div className={`${classes.itemBorder} ${classes1.invoicesWrapper}`}>
      <div>
        <div className={classes.itemUpperWrapper}>
          <div>
            <h3 className={classes.itemTitle}>
              <HelperWrapper t="transaction-history-section" />
            </h3>
          </div>
          <Button
            startIcon={<EditIcon />}
            className={classes.itemButton}
            onClick={handleSessionCreate}
            variant="contained"
          >
            <HelperWrapper t="manage-payments-button-text" />
          </Button>
        </div>
        <SubscriptionEnd subscriptionEnd={data?.subscriptionEnd || null} />
      </div>
      {data?.transactions &&
        data?.transactions.length > 0 &&
        (isTablet ? (
          <BillingTransactionsList isLoading={isLoading} transactions={data.transactions} />
        ) : (
          <BillingTransactionsTable transactions={data.transactions} />
        ))}
    </div>
  )
}

export { BillingTransactions }
